/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 過去記事検索レポートのExcel
 * @export
 * @interface ArticlePastSearchExcel
 */
export interface ArticlePastSearchExcel {
    /**
     * 
     * @type {number}
     * @memberof ArticlePastSearchExcel
     */
    reportId: number;
    /**
     * 
     * @type {number}
     * @memberof ArticlePastSearchExcel
     */
    createdStatus: ArticlePastSearchExcelCreatedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ArticlePastSearchExcel
     */
    file: string | null;
}

/**
* @export
* @enum {string}
*/
export enum ArticlePastSearchExcelCreatedStatusEnum {
    NONE = 0,
    CREATING = 1,
    CREATED = 2
}

export function ArticlePastSearchExcelFromJSON(json: any): ArticlePastSearchExcel {
    return ArticlePastSearchExcelFromJSONTyped(json, false);
}

export function ArticlePastSearchExcelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchExcel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reportId': json['report_id'],
        'createdStatus': json['created_status'],
        'file': json['file'],
    };
}

export function ArticlePastSearchExcelToJSON(value?: ArticlePastSearchExcel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report_id': value.reportId,
        'created_status': value.createdStatus,
        'file': value.file,
    };
}

